var pretifyName = function (name) {
    return name
        .replace(/[-_.]/g, ' ')
        .replace(/ +/g, ' ')
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .split(' ')
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
        .join(' ');
};
var getColumnLabel = function (column) { var _a; return typeof column === 'object' ? (_a = column.label) !== null && _a !== void 0 ? _a : pretifyName(column.key) : pretifyName(column); };
var getColumnNames = function (columns, items) {
    return columns
        ? columns.map(function (column) {
            return typeof column === 'object' ? column.key : column;
        })
        : items && getColumnNamesFromItems(items);
};
var getColumnNamesFromItems = function (items) {
    return Object.keys(items[0] || {}).filter(function (el) { return el.charAt(0) !== '_'; });
};

export { getColumnLabel, getColumnNames, getColumnNamesFromItems, pretifyName };
//# sourceMappingURL=utils.js.map
